module.exports = __webpack_public_path__ + "static/media/29ADMSPC34.d859eee9.jpg";